<template>
    <div v-wechat-title="'mysread'">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <!--頂部欄-->
        <div class="top-nav-container">
            <span>我的</span>
        </div>

        <div class="mine-container">

            <!--頭像-->
            <div class="header-container">
                <img @click="headerClick" :src="headImage" alt="">
                <span>{{nickName}}</span>
                <span style="width: 200px">ID:{{userData.frontId}}</span>
            </div>

            <div class="aline"></div>

            <div @click="recharge" class="mine-item-container">
                <img src="../assets/img_recharge.png" alt="" />
                <span>儲值異幣</span>
                <span style="color: #EA477B">余額：{{userReadCoin}}</span>
            </div>

            <div class="aline"></div>

            <div @click="readHistory" class="mine-item-container">
                <img src="../assets/img_zuji.png" alt="" />
                <span>我的足跡</span>
            </div>

            <div class="aline"></div>

            <div @click="rechargeHistory" class="mine-item-container">
                <img src="../assets/img_chongzhi.png" alt="" />
                <span>儲值記錄</span>
            </div>

            <div class="aline"></div>

            <div @click="buyHistory" class="mine-item-container">
                <img src="../assets/img_purcharge_history.png" alt="" />
                <span>購買記錄</span>
            </div>

            <div class="aline"></div>

            <div @click="questionFeedback" class="mine-item-container">
                <img src="../assets/img_kefu.png" alt="" />
                <span>問題反饋</span>
            </div>

            <div class="aline"></div>

            <div @click="privacyPolicy" href="https://b.mysread.com/privacyPolicy.php" class="mine-item-container">
                <img src="../assets/img_change_route.png" alt="" />
                <span>隱私政策</span>
            </div>

            <div class="aline"></div>

            <div @click="dataDeletion" class="mine-item-container">
                <img src="../assets/img_comment_question.png" alt="" />
                <span>資料刪除</span>
            </div>

            <div class="aline"></div>

            <div @click="logout" class="mine-item-container">
                <img src="../assets/img_logout.png" alt="" />
                <span>退出登錄</span>
            </div>

            <div class="aline"></div>
        </div>

    </div>

</template>

<script>
import headImage from "../assets/icon_portrait.png";
import axios from "axios";

export default {
    name: "MineVue",
    components: {},
    data() {
        return {
            userId: null,
            token: null,
            userData: [],
            nickName: "未登錄",
            headImage: headImage,
            userReadCoin: 0,
            isRequest: false,
        };
    },
    methods: {
        //頭像點擊
        headerClick: function () {
            if (this.userId === null || this.userId === "null") {
                this.$router.push({
                    path: "LoginVue",
                });
            }
        },

        //獲取用戶信息
        getUserMessage: function () {
            this.isRequest = true;
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getUsr");
            params.append("uid", this.userId);
            params.append("token", this.token);
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.userData = res.data.data;
                    if (
                        this.userData.headerPic !== null &&
                        this.userData.headerPic !== ""
                    ) {
                        this.headImage = this.userData.headerPic;
                    }
                    this.nickName = this.userData.nicheng;
                    this.userId = this.userData.id;
                    this.userReadCoin = this.userData.zhye;
                } else {
                    localStorage.setItem("userId", null);
                    localStorage.setItem("token", null);
                    this.userId = null;
                    this.token = null;
                }
            });
        },

        //充值
        recharge: function () {
            if (this.userId === null || this.userId === "null") {
                this.$router.push({
                    path: "LoginVue",
                });
            } else {
                this.$router.push({
                    path: "CardPayVue",
                    query: {
                        vueName: "MineVue",
                    },
                });
            }
        },

        //閱讀歷史
        readHistory: function () {
            if (this.userId === null || this.userId === "null") {
                this.$router.push({
                    path: "LoginVue",
                });
            } else {
                this.$router.push({
                    path: "LookHistoryVue",
                });
            }
        },

        //充值歷史
        rechargeHistory: function () {
            if (this.userId === null || this.userId === "null") {
                this.$router.push({
                    path: "LoginVue",
                });
            } else {
                this.$router.push({
                    path: "RechargeHistoryVue",
                });
            }
        },

        //購買記錄
        buyHistory: function () {
            if (this.userId === null || this.userId === "null") {
                this.$router.push({
                    path: "LoginVue",
                });
            } else {
                this.$router.push({
                    path: "BuyHistory",
                });
            }
        },

        //問題反饋
        questionFeedback: function () {
            if (this.userId === null || this.userId === "null") {
                this.$router.push({
                    path: "LoginVue",
                });
            } else {
                this.$router.push({
                    path: "FeedbackVue",
                });
            }
        },

        //隱私政策
        privacyPolicy: function () {
            this.$router.push({
                path: "PrivacyPolicyVue",
            });
        },

        //資料刪除
        dataDeletion: function () {
            this.$router.push({
                path: "DataDeletionVue",
            });
        },

        //退出登錄
        logout: function () {
            localStorage.setItem("userId", null);
            localStorage.setItem("token", null);
            this.userId = null;
            this.token = null;
            this.headImage = headImage;
            this.nickName = "未登錄";
            this.userReadCoin = "0";
        },
    },

    created() {
        this.userId = localStorage.getItem("userId");
        this.token = localStorage.getItem("token");
        if (this.userId !== null || this.token !== null) {
            this.getUserMessage();
        }
    },

    activated() {
        this.userId = localStorage.getItem("userId");
        this.token = localStorage.getItem("token");
        if (this.userId !== null || this.token !== null) {
            this.getUserMessage();
        }
    },
};
</script>

<style scoped>
.mine-container {
    background-color: white;
    margin-top: 50px;
    min-height: 90vh;
}

.header-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;
}

.header-container img {
    width: 20%;
}

.header-container span {
    font-size: 14px;
    line-height: 30px;
    color: #333333;
}

.mine-item-container {
    text-align: left;
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: white;
}

.mine-item-container img {
    width: 8%;
}

.mine-item-container span {
    margin-left: 10px;
    font-size: 14px;
    color: #333333;
}

.mine-item-container:active {
    background-color: #efefef;
}
</style>



// WEBPACK FOOTER //
// src/components/MineVue.vue